<template>
  <div id="hortensia">
    <section class="banner">
      <div class="container-fluid">
        <div class="add-padding">
          <h1>Le Club Hortense</h1>
          <h2>Profitez d'avantages exclusifs avec Hortense !</h2>
          <p>
            Réservez dans un hébergement de notre sélection, <br />
            Et profitez de jusqu'à 4 avantages exclusifs (surclassement, accès
            gratuit au spa, petit-déjeuner offert...)
          </p>
          <div class="banner-btn">
            <button @click="setBoolMember" class="btn">J'EN PROFITE</button>
          </div>
        </div>
      </div>
    </section>
    <section class="discover-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="top-content">
            <h2>
              Découvrir <br />
              le <span>Club Hortense</span>
            </h2>
            <p>
              Rejoindre le Club Hortense, c'est accéder à une expérience de
              voyage unique, pensée pour les amoureux d'évasion et de lieux
              d'exception. En tant que membre, vous bénéficiez d'avantages
              exclusifs, conçus pour rendre chaque séjour encore plus
              mémorable.
            </p>
          </div>
          <div class="cards-box d-none d-lg-block">
            <div class="row">
              <div class="col-lg-4">
                <div class="top-img">
                  <img
                    class="img-fluid"
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offresprivile%CC%80ges.jpg"
                    alt=""
                  />
                </div>
                <div class="bottom-content-hortensia">
                  <h3>OFFRES PRIVILÉGIÉES</h3>
                  <p>
                    Réductions et avantages réservés aux membres, y compris
                    <span>-10% sur votre premier séjour</span> pour tester
                    l'expérience Hortense.
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="top-img">
                  <img
                    class="img-fluid"
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Servicesexclusifs.jpg"
                    alt=""
                  />
                </div>
                <div class="bottom-content-hortensia">
                  <h3>SERVICES EXCLUSIFS</h3>
                  <p>
                    Attentions <span>particulières</span> et expériences
                    <span>sur mesure,</span> créées pour vous offrir un séjour
                    inoubliable, alliant confort, exclusivité et
                    personnalisation.
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="top-img">
                  <img
                    class="img-fluid"
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Programmedefide%CC%81lite%CC%81.jpg"
                    alt=""
                  />
                </div>
                <div class="bottom-content-hortensia">
                  <h3>PROGRAMME DE FIDÉLITÉ</h3>
                  <p>
                    Cumulez des points <span>à chaque réservation</span> et
                    profitez d'avantages exceptionnels.
                    <span>100€ offerts tous les 500 points</span> une fois le
                    statut Green Trotter Infinite atteint.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-block d-lg-none">
            <div class="swiper mySwiper">
              <div class="swiper-wrapper cards-box">
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      class="img-fluid"
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offresprivile%CC%80ges.jpg"
                      alt=""
                    />
                  </div>
                  <div class="bottom-content-hortensia">
                    <h5>OFFRES PRIVILÉGIÉES</h5>
                    <p>
                      Réductions et avantages réservés aux membres, y compris
                      <span>-10% sur votre premier séjour</span> pour tester
                      l'expérience Hortense.
                    </p>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      class="img-fluid"
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Servicesexclusifs.jpg"
                      alt=""
                    />
                  </div>
                  <div class="bottom-content-hortensia">
                    <h5>SERVICES EXCLUSIFS</h5>
                    <p>
                      Attentions <span>particulières</span> et expériences
                      <span>sur mesure,</span> créées pour vous offrir un
                      séjour inoubliable, alliant confort, exclusivité et
                      personnalisation.
                    </p>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      class="img-fluid"
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Programmedefide%CC%81lite%CC%81.jpg"
                      alt=""
                    />
                  </div>
                  <div class="bottom-content-hortensia">
                    <h5>PROGRAMME DE FIDÉLITÉ</h5>
                    <p>
                      Cumulez des points <span>à chaque réservation</span> et
                      profitez d'avantages exceptionnels.
                      <span>100€ offerts tous les 500 points</span> une fois
                      le statut Green Trotter Infinite atteint.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container-fluid">
      <div class="discover-button text-center">
        <button @click="setBoolMember" class="btn">
          JE REJOINS LE CLUB HORTENSE
        </button>
      </div>
    </div>
    <section class="discover-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="top-content">
            <h2>
              Comment fonctionne <br />
              le <span>Club Hortense ?</span>
            </h2>
            <p>
              Rejoindre le Club Hortense, c'est bien plus qu'une simple
              adhésion : c'est devenir un membre d'une communauté privilégiée,
              dédiée aux voyageurs exigeants. Dès votre inscription, vous
              accédez à des avantages exclusifs qui rendent chaque séjour
              encore plus agréable et personnalisé.
            </p>
          </div>
          <div class="d-block d-lg-none">
            <div>
              <div class="top-card">
                <div class="box-content">
                  <h3>
                    DES AVANTAGES <br />
                    DÈS VOTRE ADHÉSION
                  </h3>
                </div>
              </div>
              <div class="bottom-card">
                <p>
                  En rejoignant le Club Hortense, vous bénéficiez
                  immédiatement d'avantages exclusifs et offres spéciales. L
                  <span>'adhésion est gratuite</span> et vous ouvre la porte à
                  une expérience unique.
                </p>
              </div>
              <div class="vert-line"></div>
            </div>
            <div>
              <div class="top-card">
                <div class="box-content">
                  <h3>
                    PLUS VOUS SÉJOURNEZ,<br />
                    PLUS VOTRE STATUT ÉVOLUE
                  </h3>
                </div>
              </div>
              <div class="bottom-card">
                <p>
                  Votre statut au sein du Club Hortense progresse à mesure que
                  vous cumulez des séjours.
                  <span
                    >Plus vous réservez, plus <br />
                    vous bénéficiez de privilèges</span
                  >
                  et de services encore plus exclusifs.
                </p>
              </div>
              <div class="vert-line"></div>
            </div>
            <div>
              <div class="top-card">
                <div class="box-content">
                  <h3>DES AVANTAGES DÈS VOTRE ADHÉSION</h3>
                </div>
              </div>
              <div class="bottom-card">
                <p>
                  À chaque niveau de statut, vos avantages s'enrichissent :
                  <span
                    >Cadeaux personnalisés, services sur mesure et offres
                    exclusives. </span
                  >Plus vous voyagez, plus vos privilèges grandissent.
                </p>
              </div>
            </div>
          </div>
          <div class="three-cards-div">
            <div class="d-none d-lg-block">
              <div class="row justify-content-center">
                <div class="col-md-4 text-center benefit-box">
                  <div class="box-content">
                    <h3>
                      DES AVANTAGES <br />
                      DÈS VOTRE ADHÉSION
                    </h3>
                  </div>
                </div>
                <div class="col-md-4 text-center benefit-box">
                  <div class="box-content">
                    <h3>
                      PLUS VOUS SÉJOURNEZ,<br />
                      PLUS VOTRE STATUT ÉVOLUE
                    </h3>
                  </div>
                </div>
                <div class="col-md-4 text-center benefit-box">
                  <div class="box-content">
                    <h3>
                      DES AVANTAGES DE PLUS <br />
                      EN PLUS GÉNÉREUX
                    </h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 d-flex justify-content-center">
                  <div class="yellow-card">
                    <p>
                      En rejoignant le Club Hortense, vous bénéficiez
                      immédiatement d'avantages exclusifs et offres spéciales.
                      L
                      <span>'adhésion est gratuite</span> et vous ouvre la
                      porte à une expérience unique.
                    </p>
                  </div>
                </div>
                <div class="col-lg-4 d-flex justify-content-center">
                  <div class="yellow-card">
                    <p>
                      Votre statut au sein du Club Hortense progresse à mesure
                      que vous cumulez des séjours.
                      <span
                        >Plus vous réservez, plus vous bénéficiez de
                        privilèges</span
                      >
                      et de services encore plus exclusifs.
                    </p>
                  </div>
                </div>
                <div class="col-lg-4 d-flex justify-content-center">
                  <div class="yellow-card">
                    <p>
                      À chaque niveau de statut, vos avantages s'enrichissent
                      :
                      <span
                        >Cadeaux personnalisés, services sur mesure et offres
                        exclusives. </span
                      >Plus vous voyagez, plus vos privilèges grandissent.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="discover-button">
            <button @click="setBoolMember" class="btn">
              JE CRÉE MON COMPTE
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="discover-section swiper-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="top-content">
            <h2>
              Hortense a négocié <br />
              <span>pour Vous !</span>
            </h2>
            <p class="text-center" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'">
              Hortense négocie pour vous des avantages exclusifs afin de
              rendre chaque séjour encore plus exceptionnel.
            </p>
          </div>
          <div class="position-relative">
            <div class="swiper item-swiper mx-lg-5">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Petitde%CC%81jeuneroffert-Desktop.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Petit déjeuner offert</h3>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Massageoffert-Desktop+.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Massage offert</h3>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Di%CC%82neroffert-Desktop.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Dîner offert</h3>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/De%CC%81gustationdevin-Desktop.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Dégustation de vin</h3>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Bouteilledechampagne-Desktop.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Bouteille de champagne</h3>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Surclassementdechambre-Desktop.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Surclassement de chambre</h3>
                </div>
                <div class="swiper-slide">
                  <div class="top-img">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Verredebienvenue-Desktop.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <h3>Verre de bienvenue</h3>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center d-lg-none dots-page">
              <div class="item-swiper-pagination w-auto"></div>
            </div>
            <div>
              <button class="item-swiper-prev btn p-0 border-0 shadow-none">
                <img
                  src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/prev.png"
                  alt=""
                />
              </button>
              <button class="item-swiper-next btn p-0 border-0 shadow-none">
                <img
                  src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/next.png"
                  alt=""
                />
              </button>
            </div>
          </div>
          <div class="discover-button text-center">
            <button @click="setBoolMember" class="btn">JE M'INSCRIS</button>
          </div>
          <p class="left-p">
            *Les avantages exclusifs peuvent varier selon l'hébergement.
          </p>
        </div>
      </div>
    </section>
    <section class="discover-section leaf-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="top-content">
            <h2>
              Les avantages <br />
              <span>du Club Hortense</span>
            </h2>
            <p>
              Gagnez des points à chaque réservation et accédez à des services
              exclusifs dès votre adhésion ! Plus vous séjournez, plus vous
              bénéficiez d'avantages uniques, avec un statut qui évolue pour
              vous offrir des récompenses toujours plus exceptionnelles.
              Rejoignez le Club Hortense et vivez une expérience privilégiée à
              chaque escapade !
            </p>
            <br />
            <h3 class="font-weight-bold">
              PLUS D'AVANTAGES À CHAQUE STATUT DU CLUB HORTENSE
            </h3>
          </div>
          <div class="scroll-container">
            <div class="d-flex gap-0">
              <div class="inner-box-large">
                <div class="progress-step-wrapper mb-4">
                  <img
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/badge-guest%402x.png"
                    class="progress-icon mb-2"
                    alt="Green Trotter"
                  />
                  <h4
                    class="text-uppercase font-weight-bold mb-3 membership-type"
                  >
                    Green Trotter
                  </h4>
                  <div class="progress-line mx-auto my-2 position-relative">
                    <span class="progress-dot"></span>
                  </div>
                </div>
                <div class="small-box mb-3">
                  <div
                    class="d-flex align-items-center justify-content-center"
                  >
                    <h6>500 points</h6>
                    <span></span>
                    <p>Soit 10 nuits réservées</p>
                  </div>
                </div>
                <div class="large-box">
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>1<sup>er</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box locked">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockin.png"
                      alt=""
                    />
                    <p>2<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box locked">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockin.png"
                      alt=""
                    />
                    <p>3<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box locked">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockin.png"
                      alt=""
                    />
                    <p>4<sup>ème</sup> avantage exclusif</p>
                  </div>
                </div>
              </div>
              <div class="inner-box-large">
                <div class="progress-step-wrapper mb-4">
                  <img
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/badge-member%402x.png"
                    class="progress-icon mb-2"
                    alt="Green Trotter"
                  />
                  <h4
                    class="text-uppercase font-weight-bold mb-3 membership-type"
                  >
                    Green Trotter Plus
                  </h4>
                  <div class="progress-line mx-auto my-2 position-relative">
                    <span class="progress-dot"></span>
                  </div>
                </div>
                <div class="small-box mb-3">
                  <div
                    class="d-flex align-items-center justify-content-center"
                  >
                    <h6>1000 points</h6>
                    <span></span>
                    <p>Soit 20 nuits réservées</p>
                  </div>
                </div>
                <div class="large-box">
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>1<sup>er</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>2<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box locked">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockin.png"
                      alt=""
                    />
                    <p>3<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box locked">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockin.png"
                      alt=""
                    />
                    <p>4<sup>ème</sup> avantage exclusif</p>
                  </div>
                </div>
              </div>
              <div class="inner-box-large">
                <div class="progress-step-wrapper mb-4">
                  <img
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/badge-nomad%402x.png"
                    class="progress-icon mb-2"
                    alt="Green Trotter"
                  />
                  <h4
                    class="text-uppercase font-weight-bold mb-3 membership-type"
                  >
                    Green Trotter Premium
                  </h4>
                  <div class="progress-line mx-auto my-2 position-relative">
                    <span class="progress-dot"></span>
                  </div>
                </div>
                <div class="small-box mb-3">
                  <div
                    class="d-flex align-items-center justify-content-center"
                  >
                    <h6>1500 points</h6>
                    <span></span>
                    <p>Soit 30 nuits réservées</p>
                  </div>
                </div>
                <div class="large-box">
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>1<sup>er</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>2<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>3<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box locked">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockin.png"
                      alt=""
                    />
                    <p>4<sup>ème</sup> avantage exclusif</p>
                  </div>
                </div>
              </div>
              <div class="inner-box-large">
                <div class="progress-step-wrapper mb-4">
                  <img
                    src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/badge-trotter.png"
                    class="progress-icon mb-2"
                    alt="Green Trotter"
                  />
                  <h4
                    class="text-uppercase font-weight-bold mb-3 membership-type"
                  >
                    Green Trotter INFINITE
                  </h4>
                  <div class="progress-line mx-auto my-2 position-relative">
                    <span class="progress-dot"></span>
                  </div>
                </div>
                <div class="small-box mb-3">
                  <div
                    class="d-flex align-items-center justify-content-center"
                  >
                    <h6>2500 points</h6>
                    <span></span>
                    <p>Soit 50 nuits réservées</p>
                  </div>
                </div>
                <div class="large-box">
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>1<sup>er</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>2<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>3<sup>ème</sup> avantage exclusif</p>
                  </div>
                  <div class="inner-box">
                    <img
                      src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Lockout.png"
                      alt=""
                    />
                    <p>4<sup>ème</sup> avantage exclusif</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container mt-5">
      <div class="privileges-box p-4 position-relative">
        <h3
          class="privileges-heading text-center font-weight-bold position-absolute bg-white px-3"
        >
          PLUS D'AVANTAGES, PLUS DE PRIVILÈGES
        </h3>
        <div class="list-down mt-2 mt-lg-5">
          <div class="d-flex">
            <span class="plus-icon">+</span>
            <p>
              Une réduction de
              <strong>10% sur votre premier séjour</strong> réservé
            </p>
          </div>
          <div class="d-flex">
            <span class="plus-icon">+</span>
            <p>Les avantages exclusifs sont <strong>cumulables</strong></p>
          </div>
          <div class="d-flex">
            <span class="plus-icon">+</span>
            <p>
              Des <strong>cadeaux exclusifs</strong>* disponibles à partir du
              statut <em>Green Trotter Premium</em>
            </p>
          </div>
          <div class="d-flex">
            <span class="plus-icon">+</span>
            <p>
              Les séjours de plus de 3 jours incluent une
              <strong>Green expérience</strong> unique offerte par Hortense,
              pour une immersion au cœur de ce lieu d’exception.
            </p>
          </div>
        </div>
      </div>
      <div class="discover-button text-center">
        <button @click="setBoolMember" class="btn">
          JE M'INSCRIS MAINTENANT
        </button>
      </div>
    </div>
    <div class="col-lg-12 col-xs-9 add-padding" :class="isPhone ? 'pt-5' : 'ml-3 pt-4'">
      <h2 class="merriweather-reg-26 mb-4">Le parrainage Hortense</h2>
      <p class="raleway-reg-p15 pb-4">Le parrainage Hortense vous rapporte des points de fidélité et -10% sur votre prochain séjour ! <br><br>
        Invitez vos proches à rejoindre Hortense et obtenez 50 points de fidélité supplémentaires dès leur inscription ainsi que 10% de réduction sur votre prochain séjour dès leur première réservation sur la plateforme.<br><br>
        En plus, nous offrons à vos filleuls 100 points de fidélité de bienvenue, lors de leur inscription.<br><br>
        Vous retrouverez votre liste de filleuls et vos avantages dans votre compte personnel.<br><br>
        Profitez du parrainage Hortense pour faire grandir la communauté de voyageurs engagés.
      </p>
      <button @click="redirectToSponsorshipPage()" class="hortense-btn-primary mt-2">JE PARRAINE MES PROCHES</button>
    </div>
    <section class="discover-section faq-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="top-content">
            <h2>FAQ</h2>
          </div>
          <div class="accordion" id="faqAccordion">
            <div class="card border-bottom">
              <button
                class="btn btn-link w-100 text-left d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Qu'est-ce que le Club Hortense ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseOne"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Le <span> Club Hortense,</span> un programme de fidélité
                    proposé par Hortense, est gratuit pour tout voyageur qui
                    demande à y souscrire. Il est accessible à toute personne
                    de plus de 18 ans ayant créé un compte sur le site avec
                    une adresse e-mail valide. <br />
                    <br />
                    Le programme est ouvert uniquement aux particuliers.
                    <br />
                    <br />
                    En rejoignant le Club, vous pouvez accumuler des points et
                    débloquer des avantages exclusifs selon votre statut.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Comment fonctionne le Club Hortense ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Le <span>Club Hortense</span> repose sur un système de
                    statuts évolutifs. <span>À chaque réservation,</span> vous
                    accumulez des points qui vous permettent de progresser
                    vers des statuts supérieurs et de débloquer des
                    récompenses exclusives. <br />
                    <span
                      >Une nuitée réservée permet l’obtention de 50
                      points,</span
                    >
                    à l’exception des nuitées offertes ou réservées grâce à un
                    bon d’achat obtenu de points convertibles.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Comment atteindre les différents statuts du Club Hortense ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Le <span>Club Hortense</span> comporte
                    <span>4 statuts</span> de fidélité :
                  </p>
                  <br />
                  <ul>
                    <li>
                      <span> Green Trotter : </span> Accessible à partir de
                      <span>500 points cumulés soit 10 nuits réservées</span>
                      par Hortense. Ce statut permet
                      <span>de profiter d’un avantage exclusif</span> pendant
                      votre séjour en plus d
                      <span
                        >’une réduction de 10% sur votre première
                        réservation.</span
                      >
                    </li>
                    <li>
                      <span> Green Trotter Plus :</span> Accessible à partir
                      de
                      <span
                        >1000 points cumulés, soit 20 nuits réservées.</span
                      >
                      Ce statut vous permettra de profiter de
                      <span>deux avantages exclusifs</span> pendant votre
                      séjour chez un de nos partenaires Hortense.
                    </li>
                    <li>
                      <span>Green Trotter Premium :</span> Accessible à partir
                      de
                      <span
                        >1500 points cumulés, soit 30 nuits réservées.</span
                      >
                      Ce statut vous permettra de profiter de
                      <span>trois avantages exclusifs</span> pendant votre
                      séjour chez un de nos partenaires Hortense en plus d
                      <span>’un accès à des cadeaux exclusifs</span> comme
                      service conciergerie sur-mesure, guides de voyages et
                      biens d’autres surprises…
                    </li>
                    <li>
                      <span> Green Trotter Infinite :</span> Accessible à
                      partir de 2 500 points cumulés, soit 50 nuits réservées.
                      Ce statut permet de profiter de quatre avantages
                      exclusifs pendant votre séjour, d’un accès aux cadeaux
                      et de la possibilité de convertir les points en bon
                      d’achat de 100€, valable 12 mois et applicable sur
                      toutes les réservations sur la plateforme Hortense.
                    </li>
                  </ul>
                  <p>
                    👉 <span>Limite de conversion :</span> Vous pouvez
                    convertir jusqu’à <span>500 points</span> en bon d’achat.
                    La conversion entraîne une réduction de votre solde à
                    <span>2 000 points,</span> ce qui signifie un retour au
                    statut <span>Green Trotter Premium.</span>
                  </p>
                  <br />
                  <br />
                  <br />
                  <p>
                    Les avantages exclusifs peuvent varier selon
                    l’hébergement. Chaque partenaire propose des avantages
                    exclusifs différents de l’autre.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                Comment utiliser mes récompenses et bénéficier de mes
                avantages ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseFour"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Dès que vous atteignez un statut Green Trotter, vous
                    bénéficiez automatiquement des avantages exclusifs
                    associés à ce niveau lors de votre séjour chez nos
                    partenaires Hortense.
                  </p>
                  <br />
                  <p><span>Utilisation des avantages </span></p>
                  <ul>
                    <li>
                      Les avantages exclusifs sont proposés directement par
                      l’établissement partenaire lors de votre séjour. Une
                      fois votre statut débloqué, vous pourrez en profiter
                      sans démarche supplémentaire.
                    </li>
                    <li>
                      Selon votre statut, vous aurez accès à 1 à 4 avantages
                      pendant votre séjour, ainsi qu’à des cadeaux exclusifs à
                      partir du statut Green Trotter Premium.
                    </li>
                  </ul>
                  <p><span>Utilisation des points</span></p>
                  <ul>
                    <li>
                      Vous pouvez convertir jusqu’à 500 points en un bon
                      d’achat de 100€, valable 12 mois sur toutes les
                      réservations effectuées via Hortense.
                    </li>
                    <li>
                      La conversion entraîne une réduction de votre solde à 2
                      000 points, ce qui vous ramène au statut Green Trotter
                      Premium.
                    </li>
                  </ul>
                  <br />
                  <p>
                    Dès que vous atteignez un statut Green Trotter, vous
                    bénéficiez automatiquement des avantages exclusifs
                    associés à ce niveau lors de votre séjour chez nos
                    partenaires Hortense.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                Quand mes points sont-ils crédités sur mon compte ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseFive"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Vos points sont crédités
                    <span>après la fin de votre séjour,</span>
                    uniquement pour les réservations confirmées et
                    effectivement réalisées.
                  </p>
                  <ul>
                    <li>
                      Si vous annulez votre séjour, aucun point ne sera ajouté
                      à votre compte.
                    </li>
                    <li>
                      Une fois votre séjour terminé, les points sont
                      automatiquement crédités sur votre espace fidélité dans
                      un délai de quelques jours.
                    </li>
                  </ul>
                  <p>
                    Vous pouvez suivre l’évolution de votre solde de points
                    directement depuis votre compte Hortense.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                Les points et avantages expirent-ils ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseSix"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Oui, les points et avantages sont soumis à des conditions
                    d’expiration :
                  </p>
                  <ul>
                    <li>
                      Expiration des points : Les points cumulés restent
                      valables tant que vous effectuez au moins une
                      réservation tous les 24 mois. Au-delà de cette période
                      d’inactivité, votre solde de points sera remis à zéro.
                    </li>
                    <li>
                      Expiration du statut Green Trotter offert : Si votre
                      compte a été créé avec le statut Green Trotter offert,
                      vous disposez de 12 mois pour effectuer une première
                      réservation. Passé ce délai, votre statut sera perdu et
                      vous devrez cumuler des points pour l’obtenir à nouveau.
                    </li>
                    <li>
                      Expiration du bon d’achat de 100€ : Si vous convertissez
                      vos points du statut Green Trotter Infinite en bon
                      d’achat, celui-ci sera valable pendant 12 mois
                      uniquement à compter de la date de conversion.
                    </li>
                  </ul>
                  <p>
                    Vous pouvez consulter votre solde de points et la validité
                    de vos avantages à tout moment depuis votre espace
                    fidélité.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                Pourquoi ai-je perdu mon statut ? Comment le récupérer ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseSeven"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Explication du fonctionnement du programme de fidélité.
                  </p>
                  <ul>
                    <li>
                      Inactivité prolongée : Si vous n’avez effectué aucune
                      réservation pendant 24 mois, vos points cumulés sont
                      remis à zéro et vous perdez votre statut.
                    </li>
                    <li>
                      Statut Green Trotter offert non activé : Si vous avez
                      bénéficié d’un statut Green Trotter offert à la création
                      de votre compte, vous aviez 12 mois pour effectuer une
                      première réservation. Passé ce délai, votre statut a été
                      désactivé.
                    </li>
                    <li>
                      Conversion des points en bon d’achat : Si vous avez
                      converti vos points en un bon d’achat de 100€, votre
                      solde a été réduit à 2 000 points, ce qui vous a fait
                      revenir au statut Green Trotter Premium.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                Comment récupérer mon statut ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseEight"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Vous pouvez regagner un statut supérieur en accumulant à
                    nouveau des points grâce à vos réservations. Chaque nuit
                    réservée via Hortense vous rapporte 50 points. Une fois le
                    seuil du statut atteint, vous en bénéficierez
                    automatiquement lors de votre prochain séjour. <br />
                    <br />Vous pouvez suivre l’évolution de vos points et
                    statuts directement depuis votre espace fidélité.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                Combien coûte l'adhésion au club Hortense ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseNine"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    L’adhésion au club Hortense est <span>gratuite</span> et
                    automatique dès la création de votre compte. Vous
                    commencez à cumuler des points dès votre première
                    réservation et progressez dans les statuts pour bénéficier
                    d’avantages exclusifs lors de vos séjours. <br />
                    <br />
                    Il n’y a <span>aucun frais d’inscription</span> ni de
                    cotisation annuelle.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTen"
                aria-expanded="false"
                aria-controls="collapseTen"
              >
                Comment réserver avec un bon offert ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseTen"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Dès que vous atteignez le statut
                    <span>Green Trotter Infinite,</span> vous recevrez un
                    <span>email avec un code dédié</span> pour un
                    <span>bon d’achat de 100€.</span> Ce bon est valable
                    pendant <span> 12 mois</span> à compter de la réception de
                    l'email.
                    <br />
                    <br />
                    Vous disposez de <span>1 an</span> pour l'utiliser et
                    l’appliquer à une réservation sur la plateforme Hortense.
                    Le bon est valable sur toutes les réservations, à
                    condition qu’elles soient effectuées avant la date
                    d’expiration.
                    <br />
                    <br />
                    Pour utiliser votre bon, il vous suffit de saisir le code
                    lors de la validation de votre réservation.
                  </p>
                </div>
              </div>
            </div>
            <div class="card border-bottom">
              <button
                class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3"
                type="button"
                data-toggle="collapse"
                data-target="#collapseEleven"
                aria-expanded="false"
                aria-controls="collapseEleven"
              >
                Comment puis-je contacter le service client pour une question
                sur mon compte Club Hortense ?
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <div
                id="collapseEleven"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#faqAccordion"
              >
                <div class="card-body pl-0">
                  <p>
                    Notre équipe est à votre disposition, vous pouvez nous
                    contacter via :
                  </p>
                  <ul>
                    <li class="external-links">
                      <a href="https://wa.me/33626203846" target="_blank"
                        >Sur Whatsapp.
                      </a>
                    </li>
                    <li class="external-links">
                      <a
                        href="https://www.hortense.green/pages/contact/"
                        target="_blank"
                        >Formulaire de contact.</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Modalsignup
      v-if="showModal"
      :showModalLogin="showModalLogin"
      @close="closeModal"
    ></Modalsignup>
  </div>
</template>

<script>
  import Flash from 'alert/Flash.vue';
  import fetcher from 'packs/shared/api.js';
  import Swiper from 'swiper';
  import { Navigation, Pagination } from 'swiper/modules';
  import 'bootstrap';
  import 'swiper/swiper.min.css';
  import 'swiper/modules/navigation.min.css';
  import 'swiper/modules/pagination.min.css';
  import Modalsignup from 'components/modals/Modalsignup.vue';

  Swiper.use([Navigation, Pagination]);

  export default {
    name: 'hortensia',
    props: [ 'user' ],
    components : { Flash, Modalsignup },
    data() {
      return {
        status: null,
        text: null,
        privilegeRegistration: null,
        showModal: false,
        showModalLogin: true,
        isPhone: window.innerWidth <= 768,
      }
    },
    methods: {
      openModal() {
        this.$root.$emit('openModal')
      },
      async createPrivilege(){
        try {
          const response = await fetcher.post('/privileges');
          this.text = "Inscription au prpgramme de fidélité";
          this.toggleStatus('success');
          location.reload();
        }catch(e){
          this.toggleStatus('alert');
          this.text = 'Veuillez réessayer';
        }
      },
      toggleStatus(value="success") {
        this.status = this.status === value ? null : value
      },
      privilegeCondition(){
        return this.privilegeRegistration = this.user && this.user.privilege_id === null
      },
      closeModal(){
        this.showModal = false;
      },
      setBoolMember(){
        this.showModal = true;
        this.showModalLogin = false;
      },
      setBoolLogin(){
        this.showModal = true;
        this.showModalLogin = true;
      },
      redirectToSponsorshipPage() {
        if (!this.user) {
          this.setBoolLogin();
        } else {
          window.open('/sponsorships', '_blank');
        }
      }
    },
    mounted() {
      this.privilegeCondition();
      // Wait for the DOM to be fully rendered before initializing Swiper
      this.$nextTick(() => {
        new Swiper(".mySwiper", {
          slidesPerView: 1.1,
          spaceBetween: 20,
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2,
            },
          },
        });

        new Swiper(".item-swiper", {
          slidesPerView: 1.1,
          spaceBetween: 20,
          pagination: {
            el: ".item-swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".item-swiper-next",
            prevEl: ".item-swiper-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        });
      });
    },
  }
</script>
<style lang="scss" scope='app/assets/stylesheets/components/hortensia' scoped></style>